import { Component } from 'react'
import { IListProps, IListState } from '../types'
import styles from '../index.module.less'
import { YBackGroundImage } from '@/utils/style-methods'
import { IOneOneRender } from '..'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from '../trackConfig'
import classNames from 'classnames'
import { isFullCn } from '@/utils/font'
import { LangEum } from '@/constant'
// 单行

export const viewMore = {
  zh: '查看更多',
  'zh-TW': '查看更多',
  [LangEum['zh-MO']]: '查看更多',
  [LangEum['zh-TW2']]: '查看更多',
  en: `view more `,
  ja: '更に見る',
  [LangEum['zh-SG']]: '查看更多',
  [LangEum['zh-MY']]: '查看更多',
}
@withReactTrack({ createTrackConfig })
export class ListBrand extends Component<IListProps, IListState> {
  constructor(props) {
    super(props)
    const { everyClick, offset, brandList } = this.props

    this.state = {
      brandList,
      everyClick,
      offset,
      showSize: offset,
    }
  }
  // todo: 需要防止短时间触发2次
  more() {
    const { everyClick, showSize } = this.state
    const nowSize = everyClick + showSize

    this.setState({ showSize: nowSize })
  }
  render() {
    const { lang } = this.props
    let { showSize } = this.state

    const brandList = this.props.brandList || []

    if (this.props.rule === IOneOneRender.默认) showSize = brandList.length

    const data = brandList.slice(0, showSize) || []

    return (
      <div className={styles['list-brand']}>
        {data.map((item) => {
          const style = YBackGroundImage(item.brandBackImg, 3 * 280)
          const iconStyle = YBackGroundImage(item.brandLogo, 3 * 36)

          return (
            <div
              className={styles['list-brand-box']}
              key={item.brandName}
              onClick={() => this.props.goToDetail(item)}
              data-track-click="poizon_venue_component_content_click"
              data-track-exposure="poizon_venue_component_content_exposure"
              data-blockType="1642"
              data-url={item.redirectValue}
            >
              {/* 图 */}
              <div className={styles['brand-img']} style={style}></div>
              <div className={styles['brand-right-area']}>
                {/* 标记 */}
                <div className={styles['brand-icon']} style={iconStyle}></div>
                {/* 品牌名称 */}
                <div
                  className={classNames({
                    [styles['brand-name']]: true,
                    [styles['brand-en']]: !isFullCn(item.brandName),
                  })}
                >
                  {item.brandName}
                </div>
                <div className={styles['brand-desc']}>{item.interestDesc}</div>
              </div>
            </div>
          )
        })}
        {brandList.length > data.length ? (
          <div className={styles['list-more']} onClick={() => this.more()}>
            {viewMore[lang]}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}
